// fetch(`https://api.github.com/users/mrspecific`)
const selectors = {
  eventsFeed: '[data-events-feed]',
  eventsPagination: '[data-events-pagination]',
  eventsFormatPicker: '[data-events-format-picker]',
  eventsFeedOptions: '[data-events-feed-options]',
  feedStyleTrigger: '[data-feed-style-trigger]',
  eventSearchTrigger: '[data-event-search-trigger]',
  eventSearchForm: '[data-event-search-form]',
}

const getEvents = async function(args) {
  if (typeof args == 'number' || typeof args == 'string') {
    args = {
      page: args
    }
  }

  // Set the default feed to the first one found, if not specified
  if (!args.feedId) {
    const firstEventsFeed = document.querySelector(selectors.eventsFeed);

    args.feedId = firstEventsFeed.id;
  }

  // Set Default Options
  const defaultOptions = {
    page: 1,
    style: 'default',
  };

  // Set options based on args and defaults
  const options = Object.assign(defaultOptions, args);
  const eventsFeed =  document.getElementById(args.feedId);

  if (!eventsFeed) return console.log('Problem getting events');

  const eventsStyle = options.style ? `?style=${options.style}` : '';

  // Get the options from the feed
  const feedOptions =  JSON.parse(eventsFeed.querySelector(selectors.eventsFeedOptions).innerHTML);

  let apiEndpoint = 'events/all';

  if (!feedOptions || feedOptions.feed == 'all') {
    apiEndpoint = 'events/all';
  } else if (feedOptions.feed == 'just-announced') {
    apiEndpoint = 'events/just-announced'
  }

  disablePagination();

  updateURL(options.page);

  const apiUrl = `/wp-json/wlcr/v1/${apiEndpoint}/page/${options.page}${eventsStyle}`;
  // console.log(apiUrl);

  // Fetch events from the events API
  const response = await fetch(apiUrl);
  const data = await response.json();

  if (!response.ok) return false;

  const eventsFeedWrapper = wrapEventsFeed(eventsFeed);

  // Scroll to the top of the feed
  // const scrollPos = eventsFeedWrapper.offsetTop - (document.getElementById('top-bar-menu').offsetHeight);
  // window.scrollTo(0, scrollPos);

  // Replace existing feed with new feed content
  eventsFeedWrapper.innerHTML = data;

  // Update pagination & ID of feed to use specific ID (if available)
  const eventsFeedNew = eventsFeedWrapper.querySelector(selectors.eventsFeed);
  const eventsPaginationNew = eventsFeedWrapper.querySelector(selectors.eventsPagination);

  eventsFeedNew.setAttribute('id', args.feedId);

  if (eventsPaginationNew) {
    eventsPaginationNew.setAttribute('data-feed-id', args.feedId);
  }

  return response.ok;
}

// Disable Pagination to prevent multiple API calls
const disablePagination = function() {
  const paginationContainer = document.querySelector(selectors.eventsPagination);

  if (!paginationContainer) return false;

  paginationContainer.classList.add('disabled');

  setTimeout(function() {
    const paginationContainer = document.querySelector(selectors.eventsPagination);
    paginationContainer.classList.remove('disabled');
  }, 10000);
}

// Wrap the events feed so we can swap out the contents with new events
const wrapEventsFeed = function(eventsFeed) {
  if (!eventsFeed || !eventsFeed.parentNode) return eventsFeed;
  if (!eventsFeed.parentNode.hasAttribute('data-events-feed-wrapper')) {
    const wrapper = document.createElement('div');

    wrapper.setAttribute('data-events-feed-wrapper', '');
    wrapper.setAttribute('tabindex', '-1');

    eventsFeed.parentNode.insertBefore(wrapper, eventsFeed);
    wrapper.appendChild(eventsFeed);

    return wrapper;
  } else {
    return eventsFeed.parentNode;
  }
}

// Update the URL in the address bar
const updateURL = function(page) {
  const currentURL = document.location;
  let newURL = currentURL;

  if (currentURL.href.includes('/page/')) {
    newURL = currentURL.toString().replace(/(\/page\/)([0-9]+)/g, '$1' + page);
  } else if (currentURL.href.includes('/?')) {
    newURL = currentURL.toString().replace(/\/(\?)/g, `/page/${page}/$1`);
  } else {
    newURL = newURL + `page/${page}`;
  }

  history.pushState({
    id: `page/${page}`
  }, null, newURL);
}

// Listen for pagination clicks
document.addEventListener('click', async function(event) {
  let paginationPage = false;

  // Check if the target was a pagination link
	if (event.target.matches('[data-events-pagination] a')) {
    paginationPage = event.target.getAttribute('data-pagination-page');
  }

  // Check parentNode (for links with SVG icons in them)
	if (event.target.parentNode.matches('[data-events-pagination] a')) {
    paginationPage = event.target.parentNode.getAttribute('data-pagination-page');
	}

  // If this was a pagination link click, get new events
  if (paginationPage) {
    event.preventDefault();

    const eventsPagination = event.target.closest(selectors.eventsPagination);
    const feedId = eventsPagination.getAttribute('data-feed-id');
    const eventsFeed = document.getElementById(feedId);
    const args = {
      page: paginationPage,
      feedId: feedId,
      style: eventsFeed.getAttribute('data-events-feed-style'),
    }

    // Query the API to get new events
    // getEvents(args);
    // const eventsAPI = await getEvents(args);
    await getEvents(args);

    // console.log(eventsAPI);
    scrollToFeed(feedId);
    focusTopEvent(eventsFeed);
  }
}, false);

/**
 * Scroll to the top of a feed
 * @param  {string} feedId The ID of the feed to scroll to
 * @return {void}
 */
const scrollToFeed = (feedId) => {
  const scrollTarget = document.querySelector(`[data-heading-for="${feedId}"]`) || feedId;
  const targetTop = window.scrollY + scrollTarget.getBoundingClientRect().top

  // If top bar is sticky, take that into account
  const topBar = document.querySelector('.top-bar.sticky');
  const topBarHeight = topBar && topBar.offsetHeight || 0;

  const scrollPos = targetTop - topBarHeight;

  window.scrollTo(0, scrollPos);
};

const focusTopEvent = (eventsFeed) => {
  // Focus the topmost button
  const topButton = eventsFeed.querySelector('a.button');

  if (topButton) {
    topButton.focus();
  }
};

const eventsFormatPicker = document.querySelector(selectors.eventsFormatPicker);

// Listen for events format picker actions
if (eventsFormatPicker) {
  eventsFormatPicker.addEventListener('click', async function(event) {
    event.preventDefault();
    const eventsFormatPicker = document.querySelector(selectors.eventsFormatPicker);

    const styleTrigger = event.target.closest(selectors.feedStyleTrigger);

    if (!styleTrigger || !eventsFormatPicker) return;

    const feedId = eventsFormatPicker.getAttribute('data-feed-id');
    const feedFormat = styleTrigger.getAttribute('data-feed-style');

    const args = {
      page: 1,
      feedId: feedId,
      style: feedFormat,
    };

    // Query the API to get new events
    await getEvents(args);

    // Switch the active trigger
    const allStyleTriggers = eventsFormatPicker.querySelectorAll(selectors.feedStyleTrigger);

    allStyleTriggers.forEach((trigger) => {
      if (trigger.getAttribute('data-feed-style') === feedFormat) {
        trigger.classList.add('active');
      } else {
        trigger.classList.remove('active');
      }
    });

    // window.location.hash
    // var href = new URL('https://google.com?q=cats');
    let newUrl = new URL(window.location);
    newUrl.searchParams.set('style', feedFormat);

    window.history.pushState({style: feedFormat}, '', newUrl);
  });
}

const eventSearchTrigger = document.querySelector(selectors.eventSearchTrigger);
const eventSearchForm = document.querySelector(selectors.eventSearchForm);

const closeSearchForm = () => {
  eventSearchForm.classList.remove('open');

  if (eventSearchTrigger) {
    eventSearchTrigger.focus();
  }
};

const closeSearchFormListener = (event) => {
  if (eventSearchForm && event.key === 'Escape') {
    closeSearchForm();
  }
};

if (eventSearchTrigger && eventSearchForm) {
  eventSearchTrigger.addEventListener('click', () => {
    if (eventSearchForm.classList.contains('open')) {
      closeSearchForm();
      eventSearchForm.removeEventListener('keydown', closeSearchFormListener);
    } else {
      eventSearchForm.classList.add('open');
      eventSearchForm.querySelector('.event-search-query').focus();
      eventSearchForm.addEventListener('keydown', closeSearchFormListener);
    }
  });
}
